import { type Alpha2CountryCodes } from '#app/__generated__/api.js';
import { createContext } from 'react';

type PersonaContextType = {
  countryCode: Alpha2CountryCodes | null;
  hasIdentityVerifiedThroughPersona: boolean;
};

export const PersonaContext = createContext<PersonaContextType>({
  countryCode: null,
  hasIdentityVerifiedThroughPersona: false,
});
